import React from 'react';
import {
  LinkButton,
  StreamingPopOver,
  StreamingPopOverText,
  StyledButton,
} from './QuickStreamButton.styled';
import PropTypes from 'prop-types';

function QuickStreamButtonPopOver({ show, cancel, confirm, query, text }) {
  if (!show) {
    return;
  }

  return (
    <StreamingPopOver>
      <StreamingPopOverText data-testid="popover-text">
        {query}
      </StreamingPopOverText>
      <StyledButton
        type="button"
        color="danger"
        data-testid="stop-streaming-button"
        size="small"
        onClick={confirm}
      >
        {text}
      </StyledButton>
      <LinkButton
        type="button"
        data-testid="no-thanks-button"
        color="link"
        size="sm"
        onClick={cancel}
      >
        No thanks
      </LinkButton>
    </StreamingPopOver>
  );
}

QuickStreamButtonPopOver.propTypes = {
  show: PropTypes.bool,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  query: PropTypes.string,
  text: PropTypes.string,
};

export default QuickStreamButtonPopOver;
